module.exports = __webpack_public_path__ + "media/images/account-65a43993809e2852e6f95f1764c93de4.png";